import { call, put } from 'redux-saga/effects'

import * as actions from './actions'

export function* requestWorker(
  sourceType: string,
  fn: any,
  ...args: any
): Generator {
  try {
    yield put(actions.started({ sourceType }))

    const payload = yield call(fn, ...args)

    yield put(actions.succeeded({ sourceType, payload }))

    return payload
  } catch (error) {
    yield put(actions.failed({ sourceType, error }))
  } finally {
    yield put(actions.ended({ sourceType }))
  }
}

function* requestEffect(sourceType: string, fn: any, ...args: any): Generator {
  return yield call(requestWorker, sourceType, fn, ...args)
}

export default requestEffect
